// Small map for company and town pages: the same dark style, one pin or a scatter of recent registrations.
import { Map as MlMap, Marker, addProtocol } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { Protocol } from "pmtiles";
import { KIND_COLOUR } from "./palette";
import { mapStyle } from "./style";

const el = document.getElementById("mini");
if (el) {
  addProtocol("pmtiles", new Protocol().tile);
  const lat = Number(el.dataset.lat), lng = Number(el.dataset.lng), zoom = Number(el.dataset.zoom ?? 10);
  const map = new MlMap({
    container: el, style: mapStyle(`${location.origin}/tiles/uk.pmtiles`), center: [lng, lat], zoom,
    interactive: true, dragRotate: false, pitchWithRotate: false, attributionControl: { compact: true }, scrollZoom: false,
  });
  map.touchZoomRotate.disableRotation();

  const slug = location.pathname.match(/^\/town\/([^/]+)/)?.[1];
  const source = el.dataset.source;
  map.on("load", async () => {
    el.querySelector(".maplibregl-ctrl-attrib")?.classList.remove("maplibregl-compact-show");
    if (source) {
      // Portfolio map: the team's watchlist, overdue companies in red.
      const pts = (await (await fetch(source, { credentials: "same-origin" })).json()) as Array<{ n: string; name: string; lat: number; lng: number; overdue: boolean }>;
      map.addSource("pts", { type: "geojson", data: { type: "FeatureCollection", features: pts.map((p) => ({ type: "Feature", geometry: { type: "Point", coordinates: [p.lng, p.lat] }, properties: { n: p.n, name: p.name, overdue: p.overdue } })) } });
      const colour = ["case", ["get", "overdue"], KIND_COLOUR.death, KIND_COLOUR.birth] as unknown as string;
      map.addLayer({ id: "pts-glow", type: "circle", source: "pts", paint: { "circle-color": colour, "circle-radius": 11, "circle-opacity": 0.14, "circle-blur": 1 } });
      map.addLayer({ id: "pts", type: "circle", source: "pts", paint: { "circle-color": colour, "circle-radius": 5, "circle-stroke-width": 1, "circle-stroke-color": "#05070b" } });
      map.on("click", "pts", (e) => { const n = e.features?.[0]?.properties?.n; if (typeof n === "string") location.href = `/company/${n}`; });
      map.on("mouseenter", "pts", () => (map.getCanvas().style.cursor = "pointer"));
      map.on("mouseleave", "pts", () => (map.getCanvas().style.cursor = ""));
      if (pts.length) {
        const lngs = pts.map((p) => p.lng), lats = pts.map((p) => p.lat);
        map.fitBounds([[Math.min(...lngs), Math.min(...lats)], [Math.max(...lngs), Math.max(...lats)]], { padding: 40, maxZoom: 11, duration: 0 });
      }
      return;
    }
    if (!slug) {
      // Company page: one pin at the postcode centroid.
      const pin = document.createElement("div");
      pin.className = "mini-pin";
      new Marker({ element: pin }).setLngLat([lng, lat]).addTo(map);
      return;
    }
    // Town page: the latest registrations as dots.
    const pts = (await (await fetch(`/api/town/${slug}/points`)).json()) as Array<{ n: string; name: string; lat: number; lng: number }>;
    map.addSource("pts", { type: "geojson", data: { type: "FeatureCollection", features: pts.map((p) => ({ type: "Feature", geometry: { type: "Point", coordinates: [p.lng, p.lat] }, properties: { n: p.n, name: p.name } })) } });
    map.addLayer({ id: "pts-glow", type: "circle", source: "pts", paint: { "circle-color": KIND_COLOUR.birth, "circle-radius": 9, "circle-opacity": 0.12, "circle-blur": 1 } });
    map.addLayer({ id: "pts", type: "circle", source: "pts", paint: { "circle-color": KIND_COLOUR.birth, "circle-radius": 3.5, "circle-opacity": 0.85 } });
    map.on("click", "pts", (e) => { const n = e.features?.[0]?.properties?.n; if (typeof n === "string") location.href = `/company/${n}`; });
    map.on("mouseenter", "pts", () => (map.getCanvas().style.cursor = "pointer"));
    map.on("mouseleave", "pts", () => (map.getCanvas().style.cursor = ""));
    if (pts.length > 1) {
      const lngs = pts.map((p) => p.lng), lats = pts.map((p) => p.lat);
      map.fitBounds([[Math.min(...lngs), Math.min(...lats)], [Math.max(...lngs), Math.max(...lats)]], { padding: 30, maxZoom: 12, duration: 0 });
    }
  });
}
